import React, { useMemo, useCallback } from 'react';
import { useIntl, history } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Modal } from '@/components';
import { RootStore } from '@/models';
import * as API from '@/api';
import styles from './index.less';
import { requestRecording } from '@/api';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';
import ActionBtn from '../ActionBtn';
import { ActionProps } from '../ActionBtn';

interface Props extends Partial<Pick<RootStore, 'meeting'>>, Pick<ActionProps, 'order'> {
  meeting?: RootStore['meeting'];
  className?: string;
}
const RecordingBtn: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { meeting, order, className } = props;
    const { formatMessage } = useIntl();

    const requestRecordingClick = useCallback(() => {
      elkLog('点击录制按钮');
      if (!meeting?.hostUid) {
        message.info({
          content: formatMessage({ id: 'RECORDING_CANNOT_BE_STARTED' }),
          noIcon: true,
        });
        return;
      }
      if (meeting?.videoRecordingState !== 3) {
        return;
      }
      // closeShowMoreClick();
      function send() {
        meeting?.info?.channelId &&
          requestRecording(meeting?.info?.channelId).then((res) => {
            if (res.status === 1) {
              message.info({
                content: formatMessage({ id: 'REQUEST_SENT' }),
                icon: null,
              });
              elkLog('发送录制请求成功');
            }
          });
      }
      Modal.confirm({
        focusTriggerAfterClose: false,
        title: formatMessage({ id: 'REQUEST_RECORDING' }),
        okText: formatMessage({ id: 'CONFIRM' }),
        cancelText: formatMessage({ id: 'CANCEL' }),
        okButtonProps: {
          className: `popo-meeting-button`,
        },
        onOk: send,
      });
    }, [meeting?.videoRecordingState, meeting?.hostUid]);
    if (!meeting?.ableAppsMap.WebRecording) {
      return null;
    }

    return (
      <ActionBtn
        order={order}
        bottomTitle={formatMessage({ id: 'RECORD' })}
        className={classNames(styles.recordingBtn, className, {
          [styles.disable]: !meeting?.hostUid || meeting?.videoRecordingState !== 3,
        })}
        onClick={requestRecordingClick}
      >
        <Icon className={styles.icon} name="icon-luzhi" />
      </ActionBtn>
    );
  })
);

export default RecordingBtn;
